import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "./context/AuthContext";
import ScrollToHash from "./components/site/ScrollToHash";
import ChatbotMascot from "./components/site/ChatbotMascot";
import GoogleAnalytics from "./components/site/GoogleAnalytics";
import Home from "./pages/Home";
import BlogDetail from "./pages/BlogDetail";
import ProjectDetail from "./pages/ProjectDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminAuditLog from "./pages/admin/AdminAuditLog";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminInternships from "./pages/admin/AdminInternships";
import AdminContentLists from "./pages/admin/AdminContentLists";
import AdminClients from "./pages/admin/AdminClients";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import BrandSplash from "./components/site/BrandSplash";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import {
  HeroSlidesAdmin,
  ProjectsAdmin,
  LeadersAdmin,
  BlogsAdmin,
  CareersAdmin,
} from "./pages/admin/AdminResources";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToHash />
            <GoogleAnalytics />
            <BrandSplash />
            <Toaster richColors position="top-right" />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/insights/:id" element={<BlogDetail />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="hero-slides" element={<HeroSlidesAdmin />} />
                <Route path="projects" element={<ProjectsAdmin />} />
                <Route path="leaders" element={<LeadersAdmin />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="blogs" element={<BlogsAdmin />} />
                <Route path="careers" element={<CareersAdmin />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="internships" element={<AdminInternships />} />
                <Route path="content" element={<AdminContentLists />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="audit-log" element={<AdminAuditLog />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
